module.exports = __webpack_public_path__ + "static/media/no_invoices.d5d0d5c9.png";